import * as motcode_handler from '../../gift_catalogue/logic/motcode_handler.js';

export function noheader_main() {
    motcode_handler.initialize(global);
}
